import { render, staticRenderFns } from "./LogisticsTemplateManageList.vue?vue&type=template&id=bdc62d42"
import script from "./LogisticsTemplateManageList.vue?vue&type=script&lang=js"
export * from "./LogisticsTemplateManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports